import {
  AnalyticServiceContext,
  GAPackage,
  getAnalyticsValueForPackage,
} from '@grandstand-web/bally-web-shared/src/services/analytics/AnalyticService'
import { useTealium } from '@grandstand-web/bally-web-shared/src/services/tealium/TealiumService'
import { PackageObjV2 } from '@grandstand/presentation-models'
import { useContext, useRef } from 'react'

export const useSendViewedPackagesAnalytics = () => {
  const tealium = useTealium()
  const analyticService = useContext(AnalyticServiceContext)
  const viewedPackagesRef = useRef<PackageObjV2[][]>([])

  return (packages: PackageObjV2[], packagesZipcode: string, freeTrialEligible: boolean) => {
    if (!packages?.length) {
      return
    }

    // Check if we've already logged these exact packages
    const packagesJson = JSON.stringify(packages.sort((a, b) => a.package_name.localeCompare(b.package_name)))
    if (
      viewedPackagesRef.current.some(
        (prev) => JSON.stringify(prev.sort((a, b) => a.package_name.localeCompare(b.package_name))) === packagesJson
      )
    ) {
      return
    }

    // Store these packages as viewed
    viewedPackagesRef.current.push(packages)

    tealium.viewPackages({
      user_zip: packagesZipcode,
    })

    // we need to fire event for each purchase_option
    packages.forEach((pkg) => {
      const gaViewedPackages: GAPackage[] = Object.entries(pkg.purchase_options).map(([item_variant, pkgItem]) => {
        const isFreeTrial =
          freeTrialEligible &&
          pkgItem.promotions?.find((promo) => promo.is_default_promotion && promo.is_free_trial) !== undefined

        const value = getAnalyticsValueForPackage(pkgItem, isFreeTrial)
        const package_price = pkgItem.price
        const package_rsn = pkg.dtc_product_ids.join('|')

        return {
          package_zipcode: packagesZipcode,
          eligibility: 'eligible',
          message: '',
          package_rsn,
          subscription_type: isFreeTrial ? 'trial' : 'paid',
          package_price,
          value,
          ecommerce: {
            value,
            currency: 'USD',
            items: [
              {
                item_name: pkg.package_name.toLowerCase(),
                item_id: package_rsn.replace('_', ' '),
                item_brand: 'fanduel sports network',
                item_category: isFreeTrial ? 'trial' : 'paid',
                item_variant,
                quantity: 1,
                price: package_price,
              },
            ],
          },
        }
      })
      gaViewedPackages.forEach((gaViewedPackage) => analyticService.viewPackages(gaViewedPackage))
    })
  }
}
